import { ContentStickyDirective } from './content-sticky.component';

export default angular
  .module('sfMobile.components.content-sticky', ['sfMobile.components.content'])
  .directive('sfContentSticky', ContentStickyDirective).name;
